module.exports = __webpack_public_path__ + "img/Comment.efefd4f4.svg";